import { render, staticRenderFns } from "./vsNavItem.vue?vue&type=template&id=6f341d00&"
import script from "./vsNavItem.vue?vue&type=script&lang=js&"
export * from "./vsNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsNavItem.vue"
export default component.exports